export interface WebSocketError {
  type: 'connection' | 'authentication' | 'message' | 'timeout' | 'unknown'
  code: string
  message: string
  connectionId?: string
  timestamp: number
  recoverable: boolean
  originalError?: unknown
}

export const createWebSocketError = (
  type: WebSocketError['type'],
  code: string,
  message: string,
  options: Partial<
    Pick<WebSocketError, 'connectionId' | 'recoverable' | 'originalError'>
  > = {}
): WebSocketError => ({
  type,
  code,
  message,
  timestamp: Date.now(),
  recoverable: options.recoverable ?? true,
  connectionId: options.connectionId,
  originalError: options.originalError,
})

export const WebSocketErrorCodes = {
  CONNECTION_FAILED: 'WS_CONNECTION_FAILED',
  CONNECTION_TIMEOUT: 'WS_CONNECTION_TIMEOUT',
  CONNECTION_REJECTED: 'WS_CONNECTION_REJECTED',
  AUTH_FAILED: 'WS_AUTH_FAILED',
  AUTH_TOKEN_INVALID: 'WS_AUTH_TOKEN_INVALID',
  MESSAGE_SEND_FAILED: 'WS_MESSAGE_SEND_FAILED',
  MESSAGE_PARSE_ERROR: 'WS_MESSAGE_PARSE_ERROR',
  QUEUE_TIMEOUT: 'WS_QUEUE_TIMEOUT',
  MAX_RETRIES_EXCEEDED: 'WS_MAX_RETRIES_EXCEEDED',
  UNKNOWN_MESSAGE_TYPE: 'WS_UNKNOWN_MESSAGE_TYPE',
} as const

export type WebSocketErrorCode =
  typeof WebSocketErrorCodes[keyof typeof WebSocketErrorCodes]
